<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title=" !showResultLog ? $t('CargoMsg.Cargo_BatchEditCharge') : dialogTitle "
      width="1060px"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <el-alert
        v-if="hasUnlockingJob && !showResultLog"
        :title="$t('SeaExport.UnlockApplyUnlockedBanner')"
        type="warning"
        show-icon
        :closable="false"
        style="margin: 0 20px 8px"
      />
      <div v-show="!showResultLog" class="app-main-inner-row row-grid" style="height:620px;padding:0">
        <cargo-up-down-resize
          style="margin-left: 20px; margin-right: 20px"
          :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px', height:'50%'}"
          :down-style="{display: 'flex', flexDirection: 'column',paddingTop:'5px', height:'50%'}"
        >
          <template slot="up">
            <div style="display: flex;justify-content: space-between">
              <span style="font-size: 16px">{{ $t('CargoMsg.Cargo_SetEditCondition') }}</span>
              <div style="display: inline-block;">
                <el-button v-show="!showResultLog" type="primary" @click="toAdd">{{ $t('Payment.new') }}</el-button>
                <el-button v-show="!showResultLog" type="danger" @click="toRemove">{{ $t('SeaExport.Remove') }}</el-button>
                <el-button v-show="!showResultLog" type="primary" @click="matchCharge">{{ $t('CargoMsg.Cargo_MatchCharge') }}</el-button>
              </div>
            </div>
            <cargo-ag-grid
              :config-module="modifySpecialCharge ? '10010020' : '1001002'"
              :grid-options="dgCharge.gridOptions"
              :column-defs="dgChargeColumnDefs"
              :row-data="dgCharge.rowData"
              style="width:100%"
              @gridReady="params=>{dgCharge.gridApi=params.api}"
            />
          </template>

          <template slot="down">
            <span style="font-size: 16px">{{ $t('CargoMsg.Cargo_ToBeEditCharge') }}</span>
            <cargo-ag-grid
              :config-module="modifySpecialCharge ? '10010070' : '1001007'"
              :grid-options="filterCharge.gridOptions"
              :column-defs="filterChargeColumnDefs"
              :row-data="filterCharge.rowData"
              style="width:100%"
              @gridReady="params=>{filterCharge.gridApi=params.api}"
            />
          </template>
        </cargo-up-down-resize>
      </div>
      <label v-show="showResultLog" style="width:100%; verticalAlign:middle;fontWeight:bold; fontSize:14;color:red">{{ txtLog }}</label>
      <div v-show="showResultLog" class="app-main-inner-row row-grid" style="height:350px;padding:0;">
        <cargo-ag-grid
          config-module="1001003"
          :show-side-bar="false"
          :grid-options="logCharge.gridOptions"
          :column-defs="logCharge.columnDefs"
          :row-data="logCharge.rowData"
          style="width:100%;"
          @gridReady="params=>{logCharge.gridApi=params.api}"
        />
      </div>

      <span slot="footer" style="padding:10px">
        <span v-show="!showResultLog" style="float:left;margin-left: 20px;font-size: 16px;color: #454545">{{ $t('CargoMsg.Cargo_ToBeEditChargeSelected') + filterCharge.selectedRowsCount }}</span>
        <div style="float:right">
          <el-button v-show="!showResultLog" type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button v-show="showResultLog" type="primary" @click="exportExcel">{{ $t('SeaExport.ExportLog') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { Charge } from '@/class/model/act/Charge'
import { BY_CNTR_CHARGE_MEASURE, CHARGE_MEASURES } from '@/class/cargo/model/parameters/ChargeMeasure'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { getChargeList, batchEditCharge } from '@/api/seaExport/seaExportJob'
import { seaEQList } from '@/api/seaExport/seaEQ'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import { getLoading } from '@/utils/utilBaseElement'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  CHARGE_TYPE_RADIO_COST_PAY_SPECIAL,
  CHARGE_TYPE_RADIO_PAY, CHARGE_TYPE_RADIO_PAY_SPECIAL
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'EditChargeDetailDialog',
  components: {
    cargoUpDownResize
  },
  props: {
    visible: { type: Boolean, required: true },
    selectedJobs: { type: Array, default: () => [] },
    lob: { type: String, required: true },
    chargeType: { type: Number, default: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code },
    modifySpecialCharge: { type: Boolean, default: () => false } // 只修改 特殊费用
  },
  data() {
    const chargeMeasures = [BY_CNTR_CHARGE_MEASURE, ...CHARGE_MEASURES]
    const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
    const chargeItemSet = new Set(chargeItemCompatibleLanguage())
    return {
      innerVisible: false,
      BY_CNTR_CHARGE_MEASURE,
      chargeMeasures,
      eqTypes,
      chargeItemSet,
      jobSeaEqMap: new Map(),
      showResultLog: false,
      isInputZeroFee: false,
      isSpecialExpenseEntryFunction: false,
      editChargeList: [],
      // norChargeList: [],
      dialogTitle: '',
      txtLog: '',
      isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
      isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
      dgCharge: {
        gridOptions: {
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridSelectEditor,
            CargoAgGridCommonInputEditor
          },
          singleClickEdit: true,
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null,
        isClickMatchCharge: false
      },
      logCharge: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            suppressMenu: true,
            width: 100
          }, {
            headerName: this.$t('SeaExport.MeasureCurrency'),
            colId: 'measure',
            field: 'measure',
            suppressMenu: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            },
            width: 100
          }, {
            headerName: this.$t('CargoMsg.Cargo_OriginalAmount'),
            colId: 'sourceAmount',
            field: 'sourceAmount',
            suppressMenu: true,
            cellRenderer: (params) => {
              return ColumnUtils.returnTwoZeroFormatNumber(params.value)
            },
            width: 100
          }, {
            headerName: this.$t('SeaExport.NewAmount'),
            colId: 'amount',
            field: 'amount',
            suppressMenu: true,
            cellRenderer: (params) => {
              return ColumnUtils.returnTwoZeroFormatNumber(params.value)
            },
            width: 100
          }, {
            headerName: this.$t('CargoMsg.Cargo_HandleResult'),
            colId: 'chargeUpdate',
            field: 'chargeUpdate',
            suppressMenu: true,
            cellRenderer: (params) => {
              return ColumnUtils.processedLabelFunc(params.value)
            },
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      filterCharge: {
        gridOptions: {
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridSelectEditor,
            CargoAgGridCommonInputEditor
          },
          singleClickEdit: true,
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 多选（勾选框触发）
          onRowSelected: (event) => {
            // CWUI-8 生产环境勾选业务报错为空 this.gridApi
            this.filterCharge.selectedRowsCount = event.api.getSelectedRows().length
          }
        },
        rowData: [],
        gridApi: null,
        selectedRowsCount: 0
      }
    }
  },
  computed: {
    dgChargeColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'),
          colId: 'receivable',
          field: 'receivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          },
          editable: [SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST_PAY_SPECIAL.code].indexOf(this.chargeType) > -1,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Receivable') }, {
              code: false,
              value: this.$t('CargoMsg.Cargo_Dues')
            }],
            tagName: 'value',
            tagValue: 'code'
          },
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: this.modifySpecialCharge ? null : [...this.chargeItemSet],
              selectType: TYPE_NAMES.basic_data_ChargeItem,
              methodParams: this.getChargeItemFilter(),
              tagValue: 'itemId',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              callbackParams: { key: 'chargeItemId' },
              customLabel: item => this.$store.getters.language === 'zh' ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettlementCompany'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              autoKey: 'auto_0',
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
              },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {}
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          colId: 'currency',
          field: 'currency',
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              filterable: true,
              clearable: false,
              callbackParams: { key: 'currency' }
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Unit'),
          colId: 'measure',
          field: 'measure',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              clearable: false,
              filterable: true,
              fields: ['chineseName'],
              callbackParams: { key: 'measure' },
              callbackMethodType: 'value',
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
            }
          },
          onCellValueChanged: params => {
            if (params.value !== BY_CNTR_CHARGE_MEASURE.code) {
              params.data.eqSize = ''
              params.data.eqType = ''
              params.node.setDataValue('eqSize', params.data.eqSize)
              params.node.setDataValue('eqType', params.data.eqType)
            }
          },
          width: 150
        }, {
          // headerName: this.$t('CargoMsg.Cargo_EditUnitRate'),
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2,
              max: 999999999,
              min: -999999999
            }
          },
          width: 150
        }, {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          colId: 'quantity',
          field: 'quantity',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2,
              max: 999999999,
              min: 0
            }
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_DrawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Yes') }, { code: false, value: this.$t('CargoMsg.Cargo_No') }],
            tagName: 'value',
            tagValue: 'code'
          },
          width: 120
        }
        /* {
        headerName: this.$t('CargoMsg.Cargo_EditSettleAccountsTo'),
        colId: 'editAccountId',
        field: 'editAccountId',
        initialWidth: 210,
        valueFormatter: (params) => {
          return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
        },
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Company,
            tagValue: 'cmpIdx',
            tagName: 'chineseName',
            methodParams: { active: true },
            autoKey: 'auto_0',
            dataFilterFunction: (item, inputVal) => {
              if (item.cmpIdx === inputVal) {
                return true
              }
              return true
            },
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p)
      },*/
      ]
      if (!this.modifySpecialCharge) {
        columnDefs.push({
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          valueFormatter: params => {
            return ColumnUtils.eqSizeLabelFun(params.value)
          },
          editable: params => params.data.measure === BY_CNTR_CHARGE_MEASURE.code,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: EQ_SIZES,
            tagName: 'name',
            tagValue: 'code'
          },
          width: 150
        })
        columnDefs.push({
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          editable: params => params.data.measure === BY_CNTR_CHARGE_MEASURE.code,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: this.eqTypes,
            tagName: 'code',
            tagValue: 'code'
          },
          width: 150
        })
        columnDefs.push({
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          editable: (params) => {
            return params.data.receivable ? this.isCostControlled : this.isControlled
          },
          hide: this.isControlledShow,
          suppressColumnsToolPanel: this.isControlledShow,
          cellEditor: 'CargoAgGridSelectEditor',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Yes') }, {
              code: false,
              value: this.$t('CargoMsg.Cargo_No')
            }],
            tagName: 'value',
            tagValue: 'code'
          },
          width: 80
        })
      }
      return columnDefs
    },
    filterChargeColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 200
        }, {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          colId: 'currency',
          field: 'currency',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Unit'),
          colId: 'measure',
          field: 'measure',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'),
          colId: 'receivable',
          field: 'receivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', colId: 'createdBy', initialWidth: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DrawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }
      ]
      if (!this.modifySpecialCharge) {
        columnDefs.push({
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          hide: this.isControlledShow,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 80
        })
      }
      return columnDefs
    },
    isControlledShow() {
      return !(this.isControlled || this.isCostControlled)
    },
    hasUnlockingJob() {
      // 费用解锁中（unlockApplyStatus=1）的订单，编辑费用时顶部提示
      return this.selectedJobs.some(job => job && Number(job.unlockApplyStatus) === 1)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.jobSeaEqMap.clear()
        this.dgCharge.rowData = []
        this.dgCharge.isClickMatchCharge = false
        this.logCharge.rowData = []
        this.showResultLog = false
        this.editChargeList = []
        // this.norChargeList = []
        this.txtLog = ''
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
    }
    await this.prepareData()
  },
  methods: {
    async prepareData() {
      await cache.load(cacheName.OFFICE, cacheName.DEPARTMENT, cacheName.USER, cacheName.CONFIG)
      this.isInputZeroFee = parseInt(cache.config.get('InputZeroFee')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    },
    toAdd() {
      const row = new Charge().fillDefaultValue().getData()
      row.branchId = this.$store.getters.currentOfficeId
      row.receivable = this.chargeType !== SystemConstants.CHARGE_TYPE_RADIO_PAY.code && this.chargeType !== SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code
      const localCurrency = RateUtil.localCurrencyByOffice()
      row.localCurrency = localCurrency
      row.currency = localCurrency
      row.eqSize = ''
      row.eqType = ''
      row.quantity = 1
      this.dgCharge.rowData.push(row)
    },
    toRemove() {
      if (this.dgCharge.rowData.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotSelectEditConditionTips'))
        return
      }
      const rows = this.dgCharge.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotSelectEditConditionTips'))
        return
      }
      for (const row of rows) {
        const index = this.dgCharge.rowData.indexOf(row)
        this.dgCharge.rowData.splice(index, 1)
      }
    },
    async toSave() {
      if (!this.dgCharge.isClickMatchCharge) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMatchDataFirstTips'))
        return
      }
      if (this.dgCharge.rowData.length === 0) {
        this.$message.warning(this.$t('Message.NoAddedCharge'))
        return
      }
      if (!await this.checkDgCharge()) {
        return
      }
      if (!await ChargeUtils.checkUnitRate(this.dgCharge.rowData, this, false)) {
        return
      }
      const rows = this.filterCharge.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotSelectEditTips'))
        return
      }

      this.editChargeList = []
      for (let i = rows.length - 1; i >= 0; i--) {
        const c = rows[i]
        c.chargeUpdate = false
        if (this.checkChargeRefresh(c)) {
          const mCharge = this.getMatchCharge(c)
          c.sourceAmount = c.amount
          if (mCharge != null) {
            c.chargeUpdate = true
            c.unitRate = mCharge.unitRate
            // 同步数量和是否需要开票字段
            if (mCharge.quantity !== undefined) {
              c.quantity = mCharge.quantity
            }
            if (mCharge.needInvoice !== undefined) {
              c.needInvoice = mCharge.needInvoice
            }
            ChargeUtils.calculateTax(c, c.unitRate * c.quantity, c.taxRate)
            // 特殊费用 不设置 受控状态
            if (!this.modifySpecialCharge) {
              c.controlled = mCharge.controlled
            }
            this.editChargeList.push(c)
          }
        }
      }

      await this.$confirm(this.$t('CargoMsg.Cargo_SureEdit', [this.filterCharge.selectedRowsCount]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        if (this.editChargeList.length === 0) {
          this.showLogResult()
          return
        }

        batchEditCharge(this.editChargeList).then(res => {
          // if (res.data > 0) {
          this.$message.success(this.$t('Message.ChargeWasSuccessfullyUpdated'))
          this.showLogResult()
          // } else {
          //   this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
          // }
        })
      }).catch(() => {
      })

      /* for (const charge of this.dgCharge.rowData) {
        charge.unitRate = Number(charge.unitRate)
        if (isNaN(charge.unitRate) || !charge.unitRate) {
          charge.taxRate = 0.00
        }
        if (charge.chargeItemId <= 0) {
          this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
          return
        }
        if (charge.measure === BY_CNTR_CHARGE_MEASURE.code && (!charge.eqSize && !charge.eqType)) {
          this.$message.error(this.$t('CargoMsg.Cargo_PleaseEnterBoxTypeOrBoxType'))
          return
        }
      }
      const byCntrChargeMeasureIndex = this.dgCharge.rowData.findIndex(p => p.measure === BY_CNTR_CHARGE_MEASURE.code)
      if (byCntrChargeMeasureIndex >= 0) {
        for (const job of this.selectedJobs) {
          if (!this.jobSeaEqMap.has(job.uuid)) {
            const seaEqs = await seaEQList({ jobUuid: job.uuid }).then(res => res.data)
            this.jobSeaEqMap.set(job.uuid, seaEqs)
          }
        }
      }
      const item = await this.groupUpdateJobList()
      const noUpdateList = item['result']
      const updateList = item['result2']
      for (const job of updateList) {
        const charges = await getChargeList(job.uuid).then(res => res.data)
        for (let i = charges.length - 1; i >= 0; i--) {
          const c = charges[i]
          c.chargeUpdate = false
          if (this.checkChargeRefresh(c)) {
            const mCharge = this.getMatchCharge(c)
            c.jobNo = job.jobNo
            c.sourceAmount = c.amount
            if (mCharge != null) {
              c.chargeUpdate = true
              c.unitRate = mCharge.unitRate
              ChargeUtils.calculateTax(c, c.unitRate * c.quantity, c.taxRate)
              this.editChargeList.push(c)
            }
          }
        }
      }
      for (const job2 of noUpdateList) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.branchId = this.$store.getters.currentOfficeId
        charge.chargeUpdate = false
        charge.amount = 0.0
        charge.sourceAmount = 0.0
        charge.jobNo = job2.jobNo
        this.norChargeList.push(charge)
      }
      if (this.editChargeList.length === 0) {
        this.$confirm(this.$t('Message.NotMatchingTheCostOfTheProjectCanBeUpdated'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          type: 'info'
        }).then(() => {
          this.showLogResult()
        })
        return
      }*/
    },
    showLogResult() {
      this.dialogTitle = this.$t('CargoMsg.Cargo_ShowChargeEditResult')
      this.showResultLog = true
      // this.txtLog = this.$t('Message.TotalCost1') + (this.editChargeList.length + this.norChargeList.length) +
      //   this.$t('Message.TotalCost2') + this.$t('Message.Updated1') + this.editChargeList.length +
      //   this.$t('Message.Updated2') + this.$t('Message.NotUpdated1') +
      //   this.norChargeList.length + this.$t('Message.NotUpdated2')

      this.txtLog = this.$t('CargoMsg.Cargo_EditTips', [this.editChargeList.length])
      this.logCharge.rowData = [...this.editChargeList]
    },
    // 分组费用
    async groupUpdateJobList() {
      const result = []
      const result2 = []
      for (const job of this.selectedJobs) {
        const charges = await getChargeList(job.uuid).then(res => res.data)
        let match = false
        for (let i = charges.length - 1; i >= 0; i--) {
          const c = charges[i]
          if (this.checkChargeRefresh(c) && this.getMatchCharge(c) != null) {
            match = true
            result2.push(job)
            break
          }
        }
        if (!match) {
          result.push(job)
        }
      }
      return { 'result': result, 'result2': result2 }
    },
    // 更新匹配的费用
    getMatchCharge(charge) {
      if (!this.dgCharge.rowData || this.dgCharge.rowData.length === 0) {
        return charge
      }
      const charges = this.dgCharge.rowData
      for (let i = charges.length - 1; i >= 0; i--) {
        const c = charges[i]
        // 界面输入框内容 1:true,0:false
        if (c.receivable === charge.receivable &&
          Number(c.chargeItemId) === charge.chargeItemId &&
          c.currency === charge.currency &&
          (!c.accountId || Number(c.accountId) === Number(charge.accountId)) &&
          (!c.invoiceTitle || c.invoiceTitle === charge.invoiceTitle)) {
          // 特殊费用 不用根据 箱型、箱量 匹配
          if (c.measure === BY_CNTR_CHARGE_MEASURE.code && !this.modifySpecialCharge) {
            const seaEqs = this.jobSeaEqMap.get(charge.jobUuid)
            if (seaEqs) {
              for (const seaEq of seaEqs) {
                let flag = false
                if (c.eqSize) {
                  if (c.eqSize === seaEq.eqSize) {
                    flag = c.eqType && this.eqTypeMap(c.eqType) === this.eqTypeMap(seaEq.eqType) || !c.eqType
                  }
                } else {
                  flag = c.eqType && this.eqTypeMap(c.eqType) === this.eqTypeMap(seaEq.eqType)
                }
                if (flag) {
                  const measure = this.eqToChargeMeasure(seaEq)
                  if (measure === charge.measure) {
                    return c
                  }
                }
              }
            }
          } else if (c.measure === charge.measure) {
            return c
          }
        }
      }
      return null
    },
    /**
     * eqType映射（HQ和HC视为同一种箱种）
     */
    eqTypeMap(eqType) {
      if (eqType === 'HQ') {
        return 'HQ_HC'
      } else if (eqType === 'HC') {
        return 'HQ_HC'
      } else {
        return eqType
      }
    },
    eqToChargeMeasure(seqEq) {
      let measure = ''
      switch (seqEq.eqSize) {
        case '20':
          measure = 'C20'
          break
        case '40':
          if (seqEq.eqType === 'HC') {
            measure = 'C40H'
          } else {
            measure = 'C40'
          }
          break
        case '45':
          measure = 'C45'
          break
      }
      return measure
    },
    // 是否可编辑
    checkChargeRefresh(item) {
      if (item.verifiedAmount !== 0 || item.billingUuid ||
        item.billingPaymentUuid || item.invoiceUuid ||
        item.shared || item.collection || item.chargeState > 0 ||
        item.voucherDate || item.voucherJob || item.voucherBilling || item.voucherInvoice ||
        // 过滤特殊费用
        (this.modifySpecialCharge && !item.special)) {
        return false
      }
      return true
    },
    exportExcel() {
      const self = this
      const rows = []
      this.logCharge.gridApi.forEachNode((node, index) => {
        const charge = node.data
        charge.chargeUpdate = ColumnUtils.processedLabelFunc(charge.chargeUpdate)
        charge.measure = ColumnUtils.measureLabelFunction(charge.measure)
        rows.push(charge)
      })
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          this.$t('CargoMsg.Cargo_BusinessNo'),
          this.$t('SeaExport.MeasureCurrency'),
          this.$t('CargoMsg.Cargo_OriginalAmount'),
          this.$t('SeaExport.NewAmount'),
          this.$t('CargoMsg.Cargo_HandleResult')
        ]
        const filterVal = ['jobNo', 'measure', 'sourceAmount', 'amount', 'chargeUpdate']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: ColumnUtils.dateTimeFunc(new Date())
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    getChargeItemFilter() {
      let filter = {}
      switch (this.lob) {
        case 'SE':
          filter = { seaExport: true, active: true }
          break
        case 'SI':
          filter = { seaImport: true, active: true }
          break
        case 'AE':
          filter = { airExport: true, active: true }
          break
        case 'AI':
          filter = { airImport: true, active: true }
          break
        case 'RE':
        case 'RI':
          filter = { railwayExport: true, active: true }
          break
        case 'FBA_SE':
          filter = { fbaSea: true, active: true }
          break
        case 'FBA_AE':
          filter = { fbaAir: true, active: true }
          break
        case 'FBA_RE':
          filter = { fbaRailway: true, active: true }
          break
        case 'IE':
          filter = { integratedJob: true, active: true }
          break
        default:
      }
      if (this.modifySpecialCharge) {
        filter.specialExpenseMarker = true
      } else {
        const isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
        if (isSpecialExpenseEntryFunction) {
          filter.specialExpenseMarker = false
        }
      }
      return filter
    },
    onCellChange(params) {
      const { node, data } = params
      const filed = params.colDef.field
      switch (filed) {
        case 'chargeItemId':
          this.refreshChargeItemId(node, data)
          break
      }
    },
    // 费用名称
    refreshChargeItemId(node, data) {
      if (!data.chargeItemId) {
        return
      }
      const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', data.chargeItemId)
      data.taxRate = chargeItem ? (chargeItem.taxRate || 0) : 0
      // CARGO-31003 在新增费用时，直接对特定的费用进行受控
      data.controlled = chargeItem?.controlled
      data.needInvoice = chargeItem?.needInvoice
      node.setDataValue('controlled', data.controlled)
    },
    // 匹配费用
    async matchCharge() {
      this.dgCharge.isClickMatchCharge = true
      if (this.dgCharge.rowData && this.dgCharge.rowData.length > 0) {
        if (!await this.checkDgCharge()) {
          return
        }
        if (!this.isInputZeroFee) {
          const row = this.dgCharge.rowData.find(charge => isNaN(charge.unitRate) || !charge.unitRate)
          if (row) {
            this.$message.warning(this.$t('Message.UnitPriceCannotBeZero'))
            return
          }
        }
      }
      // const item = await this.groupUpdateJobList()
      // const updateList = item['result2']
      // const canDeleteChargeKeys = []
      this.filterCharge.rowData = []
      this.loading = getLoading()
      for (const job of this.selectedJobs) {
        const charges = await getChargeList(job.uuid).then(res => res.data)
        for (let i = charges.length - 1; i >= 0; i--) {
          const c = charges[i]
          c.chargeUpdate = false
          if (this.checkChargeRefresh(c)) {
            const mCharge = this.getMatchCharge(c)
            c.sourceAmount = c.amount
            if (mCharge != null) {
              // c.chargeUpdate = true
              // c.unitRate = mCharge.unitRate
              // // if (mCharge.editAccountId) {
              // //   c.accountId = mCharge.editAccountId
              // // }
              // ChargeUtils.calculateTax(c, c.unitRate * c.quantity, c.taxRate)
              this.filterCharge.rowData.push(c)
              // canDeleteChargeKeys.push(c.uuid)
            }
          }
        }
      }
      this.loading.close()
      this.filterCharge.selectedRowsCount = 0
      this.$nextTick(async() => {
        this.filterCharge.gridApi.selectAll()
      })
    },
    async checkDgCharge() {
      // 必填校验
      for (const charge of this.dgCharge.rowData) {
        charge.unitRate = Number(charge.unitRate)
        if (charge.chargeItemId <= 0) {
          this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
          return false
        }
        if (charge.measure === BY_CNTR_CHARGE_MEASURE.code && (!charge.eqSize && !charge.eqType)) {
          this.$message.error(this.$t('CargoMsg.Cargo_PleaseEnterBoxTypeOrBoxType'))
          return false
        }
      }
      const byCntrChargeMeasureIndex = this.dgCharge.rowData.findIndex(p => p.measure === BY_CNTR_CHARGE_MEASURE.code)
      if (byCntrChargeMeasureIndex >= 0) {
        for (const job of this.selectedJobs) {
          if (!this.jobSeaEqMap.has(job.uuid)) {
            const seaEqs = await seaEQList({ jobUuid: job.uuid }).then(res => res.data)
            this.jobSeaEqMap.set(job.uuid, seaEqs)
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
  #app .app-main-inner ::v-deep .el-dialog__body {
    padding: 10px;
  }
</style>
